"use client"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import CopyLinkButton from "@src/components/CopyLinkButton"
import Icons from "@src/components/Icons"
import LikeIcon from "@src/components/CollectionCard/LikeIcon"

const TitleSection = ({ collectionId, slug, name = "", likes = 0 }) => {
  return (
    <Box width="100%">
      <Typography fontSize="48px" fontWeight={700} lineHeight="58px" mb="48px">
        {name}
      </Typography>
      <Stack direction="row" gap="16px" alignItems="center">
        <CopyLinkButton
          url={`${process.env.NEXT_PUBLIC_BASE_URL}/collection/${slug}`}
        />

        <Stack direction="row" gap="8px" alignItems="center">
          <LikeIcon collectionId={collectionId} slug={slug} />
          <Typography>{likes}</Typography>
        </Stack>
      </Stack>
    </Box>
  )
}

export default TitleSection
